<template>
    <div>
        <span @click.prevent.stop="show()">
            <slot>Action</slot>
        </span>
        <portal to="panel_content">
            <div v-if="isOpen" class="panel__container confirmation">
                <article data-locator="confirmation" class="box">
                    <slot name="header">
                        <header class="confirmation__header">
                            <h3 class="confirmation__title">
                                <slot name="title"><slot name="header">Are you sure?</slot></slot>
                            </h3>
                        </header>
                    </slot>
                    <p class="confirmation__label"><slot name="message"></slot></p>
                </article>
                <footer class="panel__footer">
                    <a @click.prevent="hide()" href="#" :disabled="isBusy" class="button button--small button--outline">Back</a>
                    <button @click.prevent="confirm()" :disabled="isBusy" class="button button--small button--primary" :class="{'button--primary': destructive === false, 'button--danger': destructive === true}">{{ action }}</button>
                </footer>
            </div>
        </portal>
    </div>
</template>
<script>

export default {
    props: {
        callback: {
            required: true,
            type: Function
        },

        destructive: {
            required: false,
            type: Boolean,
            default: false
        },

        action: {
            required: false,
            type: String,
            default: 'Confirm'
        }
    },

    data () {
        return {
            isOpen: false,
            isBusy: false
        }
    },

    methods: {
        show () {
            this.isOpen = true
        },

        hide () {
            this.isOpen = false
        },

        async confirm () {
            if (this.isBusy) {
                return
            }

            this.isBusy = true

            await this.callback()

            this.isBusy = false
            this.hide()
        }
    }
}
</script>
